/**
 * 手動發送管理 API Service
 */

import apiClient from '../axios.js';

export const manualIssuanceService = {
  /**
   * 預覽符合條件的會員數量（優惠券）
   * @param {Object} data - 預覽資料
   * @returns {Promise<Object>} 預覽結果
   */
  async previewCouponIssuance(data) {
    const response = await apiClient.post('/admin/manual-issuance/coupons/preview', data);
    return response;
  },

  /**
   * 預覽符合條件的會員數量（點數）
   * @param {Object} data - 預覽資料
   * @returns {Promise<Object>} 預覽結果
   */
  async previewPointsIssuance(data) {
    const response = await apiClient.post('/admin/manual-issuance/points/preview', data);
    return response;
  },

  /**
   * 執行優惠券發放
   * @param {Object} data - 發放資料
   * @returns {Promise<Object>} 發放記錄
   */
  async executeCouponIssuance(data) {
    const response = await apiClient.post('/admin/manual-issuance/coupons/execute', data);
    return response;
  },

  /**
   * 執行點數發放
   * @param {Object} data - 發放資料
   * @returns {Promise<Object>} 發放記錄
   */
  async executePointsIssuance(data) {
    const response = await apiClient.post('/admin/manual-issuance/points/execute', data);
    return response;
  },

  /**
   * 查詢發放進度/結果（優惠券）
   * @param {string} issuanceId - 發放 ID
   * @returns {Promise<Object>} 發放記錄
   */
  async getCouponIssuanceProgress(issuanceId) {
    const response = await apiClient.get(`/admin/manual-issuance/coupons/${issuanceId}/progress`);
    return response;
  },

  /**
   * 查詢發放結果（優惠券）
   * @param {string} issuanceId - 發放 ID
   * @returns {Promise<Object>} 發放記錄
   */
  async getCouponIssuanceResult(issuanceId) {
    const response = await apiClient.get(`/admin/manual-issuance/coupons/${issuanceId}/result`);
    return response;
  },

  /**
   * 查詢發放結果（點數）
   * @param {string} issuanceId - 發放 ID
   * @returns {Promise<Object>} 發放記錄
   */
  async getPointsIssuanceResult(issuanceId) {
    const response = await apiClient.get(`/admin/manual-issuance/points/${issuanceId}/result`);
    return response;
  },

  /**
   * 查詢發放歷史
   * @param {Object} params - 查詢參數
   * @returns {Promise<Object>} 發放歷史列表
   */
  async getIssuanceHistory(params) {
    const response = await apiClient.get('/admin/manual-issuance/history', { params });
    return response;
  }
};
